import { initialAddressValue } from './schema';

export const transformAddressDataToFormdata = (addressApiData: any) => {
  const formData: typeof initialAddressValue = {
    ...initialAddressValue,
    country: addressApiData?.country ? { name: addressApiData?.country, iso: addressApiData?.country } : '',
    city: addressApiData?.city || '',
    state: addressApiData?.state || '',
    address_1: addressApiData?.address_1 || '',
    address_2: addressApiData?.address_2 || '',
    zip_code: addressApiData?.zip_code || '',
  };

  return formData;
};
